import React from "react";

/**
 * A custom hook that triggers a callback when a mousedown event occurs outside of the referenced element.
 *
 * @param {() => void} callback - The callback function to be executed when a mousedown event is detected outside the referenced element.
 * @returns {React.RefObject} - A React ref to be attached to the element you want to detect outside clicks for.
 */
function useExistFocus(callback: () => void) {
  const ref = React.useRef<any>();

  React.useEffect(() => {
    const handleClick = (event: any) => {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    };

    document.addEventListener("mousedown", handleClick);

    return () => {
      document.removeEventListener("mousedown", handleClick);
    };

    // eslint-disable-next-line
  }, [callback]); // Changed dependency to callback

  return ref;
}

export default useExistFocus;
